var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('Modal',{staticClass:"show",attrs:{"open":_vm.open,"title":_vm.title},on:{"closeModal":_vm.closeModal}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }